module.exports = __webpack_public_path__ + "static/media/redeem-step-3.39d30e83.svg";